
import { AbstractDisplayComponent } from "../../core/displays/AbstractDisplayComponet";
import { Reels } from "../../core/reels/Reels";

export class ReelComponent extends AbstractDisplayComponent {
    private container: Reels;

    public override init() {
        super.init();
        this.container = new Reels();
    }

    public getInstance(): Reels {

        return this.container;

    }

    public override destroy(): void {

        this.container.destroy();

    }

}

